import { useAsyncData } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useProductListRating(id: string) {
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    `product-rating-${id}`,
    () =>
      $httpFetch('/reviews/product-landings/:uuid/products/reviews-summary', {
        pathParams: { uuid: id },
        ...(import.meta.server && { timeout: 500 }),
      }),
    {
      default: () => null,
      lazy: true,
    },
  )
}
